// Row-level open props for list/table rows that behave like a button:
// pointer cursor, focusable, and openable via Enter or Space so a keyboard
// user gets the same affordance as pointer users. Returns undefined when the
// row is not activatable so nothing is rendered.
export const clickableRowProps = (onOpen, isClickable = true) => {
    if (!isClickable || typeof onOpen !== 'function') return undefined;
    const activate = (event) => {
        event.preventDefault();
        onOpen();
    };
    return {
        role: 'button',
        tabIndex: 0,
        onClick: activate,
        onKeyDown: (event) => {
            if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                activate(event);
            }
        },
        style: { cursor: 'pointer' },
    };
};
